import { ReferenceInput as RAReferenceInput, ReferenceInputProps } from 'react-admin';

/**
 * Custom ReferenceInput that automatically uses /references endpoint
 * 
 * This component wraps React Admin's ReferenceInput and automatically
 * adds meta.useReferenceEndpoint flag so the dataProvider uses the /references endpoint.
 * 
 * Reference endpoints are lighter, return minimal data, and use smart permission checking.
 * 
 * @example
 * <ReferenceInput source="userId" reference="user">
 *   <AutocompleteInput optionText="name" />
 * </ReferenceInput>
 */
export const ReferenceInput = (props: ReferenceInputProps) => {
    return (
        <RAReferenceInput
            {...props}
            queryOptions={{
                ...(props.queryOptions || {}),
                meta: {
                    ...(props.queryOptions?.meta || {}),
                    useReferenceEndpoint: true,
                },
            }}
        />
    );
};

